<template>
    <div class="new_fiat">
        <!-- 步骤条 -->
        <div class="step1">
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/dui_icon.png" alt="">
                    <img class="s_img2" src="../../../assets/img/xian1.png" alt="">
                </div>
                <div class="div1">{{$t('main.text389')}}</div>
            </div>
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/dui_icon.png" alt="">
                    <img class="s_img2" src="../../../assets/img/xian2.png" alt="">
                </div>
                <div class="div1">{{$t('main.text365')}}</div>
            </div>
            <div class="step1_1">
                <div class="s_img_box">
                    <img class="s_img1" src="../../../assets/img/num3_active.png" alt="">
                </div>
                <div class="div1">{{$t('main.text390')}}</div>
            </div>
        </div>
        
        <div class="th_info">
            <div class="th_info_top">
                <div class="info_top1">{{$t('main.text390')}}</div>
                <div class="info_top2">{{$t('main.text397')}}</div>
            </div>
            <div class="th_info_main">
                <div class="th_tit1">{{$t('main.text398')}}</div>
                <!-- <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text458')}}</div>
                    <div class="th_tit4">{{set_txt(api_data_obj.token_type)}} {{set_num3(data_v)}}</div>
                </div> -->
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.r_w_get')}}</div>
                    <div class="th_tit4">{{set_txt(api_data_obj.token_type)}} {{Recipient_will_get(data_v,fixed_fee,processing_fee)}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Conversion_fee')}}{{processing_rate*100}}%</div>
                    <div class="th_tit4">{{set_txt(api_data_obj.token_type)}} {{set_num3(processing_fee)}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Flat_Fee')}}</div>
                    <div class="th_tit4">{{set_txt(api_data_obj.token_type)}} {{set_num3(fixed_fee)}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('bank_card.Amount_Deducted')}}</div>
                    <div class="th_tit4">{{set_txt(api_data_obj.token_type)}} {{set_num3(data_v)}}</div>
                </div>

                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text350')}}</div>
                    <div class="th_tit4">{{api_data_obj.to_token_type}} {{set_num3((api_data_obj.value)*1)}}</div>
                </div>

                <div class="th_tit1 title_bottom">{{$t('main.text351')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text352')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.name}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text280')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.account_number}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text348')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.beneficiary_name}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text353')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.swift_code}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text277')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.address}}</div>
                </div>

                <div class="th_tit1 title_bottom">{{$t('main.text354')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text355')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.intermediary_name||'-'}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text356')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.intermediary_country||'-'}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text357')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.intermediary_swift_code||'-'}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text358')}}</div>
                    <div class="th_tit4">{{api_data_obj.details.intermediary_address||'-'}}</div>
                </div>

                <div class="th_tit1 title_bottom">{{$t('main.text405')}}</div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text360')}}</div>
                    <div class="th_tit4">{{api_data_obj.purpose}}</div>
                </div>
                <div class="th_tit2">
                    <div class="th_tit3">{{$t('main.text35')}}</div>
                    <div class="th_tit4">
                        <span v-if="api_data_obj.email">{{api_data_obj.email}}</span>
                        <span v-else> - </span>
                    </div>
                </div>

                <div class="th_tit2 flex_center">
                    <div class="th_tit3">{{$t('main.text399')}}</div>
                    <div class="th_tit4">
                        <div class="inp_box">
                            <el-input class="inp1" v-model="email_code"></el-input>
                            <div v-show="show" class="inp2 border_set_color3" @click="send_email_btn">{{$t('main.text198')}}</div>
                            <div v-show="!show" class="inp2 border_set_color3">{{$t('main.text198')}}({{count}})</div>
                        </div>
                    </div>
                </div>
                <div class="th_tit2 flex_center">
                    <div class="th_tit3">{{$t('login_google.e_google_code')}}</div>
                    <div class="th_tit4">
                        <div class="inp_box">
                            <el-input class="inp1" v-model="e_google_code"></el-input>
                        </div>
                    </div>
                </div>

                <div class="btn_box" @click="extract_confirm">{{$t('main.text400')}}</div>

            </div>
        </div>

    <!-- 提币成功 我们会联系你 -->
    <el-dialog
      :visible.sync="mention_money_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      @close="dlg_close"
      :show-close="false"
      width="480px">
      <div class="log_out1">
          <img style="width:35px;" src="../../../assets/img/Pigeon_icon.png" alt="">
      </div>
      <div class="log_out2 padding1">
        {{$t('main.text401')}}
      </div>
      <div class="log_out3 padding2">
        {{$t('main.text402')}}
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="confirm_btn2" @click="mention_money_dlg=false">{{$t('main.text266')}}</el-button>
      </span>
    </el-dialog>

    </div>

</template>

<script>
import {sendEmail,withdraw_payee_add,withdraw_crypto_withdraw} from '@/api/api';
import BigNumber from "bignumber.js";
export default {
    data() {
        return {
            mention_money_dlg:false,

            email_code:'',
            api_data_obj:{
                details:{}
            },
            show: true,//60秒 倒计时
            count: '',
            timer: null,
            u_email:'',
            xingx:false,
            data_v:JSON.parse(localStorage.getItem('data_value')),
            fixed_fee:JSON.parse(localStorage.getItem('calc_fixed_fee')),
            processing_fee:JSON.parse(localStorage.getItem('calc_processing_fee')),
            processing_rate:JSON.parse(localStorage.getItem('calc_processing_rate')),
            e_google_code:"",
        }
    },
    beforeDestroy(){
        sessionStorage.removeItem('top_title_name');
    },
    mounted() {
        sessionStorage.setItem('top_title_name',this.$t('main.text452'));
        let sess_data=JSON.parse(sessionStorage.getItem("fb_bz_1"));
        this.api_data_obj=sess_data;
        this.u_email=sessionStorage.getItem('u_email');

        // 星星 是否收藏
        this.xingx= sessionStorage.getItem("fa_xingx");
    },
    methods:{
        Recipient_will_get(v1,v2,v3){
            return BigNumber(v1).minus(v2).minus(v3).toFixed(2,0);
        },
        set_txt(v){
            if(v&&v.indexOf('-')!=-1){
                return v.split("-")[0];
            }
        },
        send_email_btn(){
            sendEmail({
                email:this.u_email,
                type:'withdrawCrypto',
            }).then(res=>{
                if(res.data.code==207){
                    this.message.ismessage('success',res.data.msg);
                    this.getCode();
                }else{
                    this.message.ismessage('error',res.data.msg);
                }
            })
        },
        getCode(){
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
                } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
                }
                }, 1000)
            }
        },
        extract_confirm(){
            if (!this.email_code) {
                return this.message.ismessage('error',this.$t('main.text403'));
            }
            if (!this.e_google_code) {
                return false;
            }
            this.api_data_obj.authCode=this.email_code;
            this.api_data_obj.google_code=this.e_google_code;
            if (this.api_data_obj.authCode) {
                // 星星 是否收藏 add
                if (this.xingx=='true') {
                    withdraw_crypto_withdraw(this.api_data_obj).then(res=>{
                        if (res.data.code==200) {
                            withdraw_payee_add({
                                name:this.api_data_obj.details.name,
                                address:this.api_data_obj.details.address,
                                account_number:this.api_data_obj.details.account_number,
                                beneficiary_name:this.api_data_obj.details.beneficiary_name,
                                swift_code:this.api_data_obj.details.swift_code,
                                intermediary_name:this.api_data_obj.details.intermediary_name,
                                intermediary_address:this.api_data_obj.details.intermediary_address,
                                intermediary_country:this.api_data_obj.details.intermediary_country,
                                intermediary_swift_code:this.api_data_obj.details.intermediary_swift_code
                            }).then(res=>{
                                if (res.data.code==200) {
                                    this.mention_money_dlg=true;
                                }else{
                                    this.message.ismessage('error',res.data.msg);
                                }
                            })

                        }else if(res.data.code==510){
                            // 手续费有变化
                            this.message.ismessage('error',res.data.msg);
                            this.$router.push('/blockchain_w/transfer_p_fiat');
                        }else{
                            this.message.ismessage('error',res.data.msg);
                        }
                    })

                }else{
                    withdraw_crypto_withdraw(this.api_data_obj).then(res=>{
                        if (res.data.code==200) {
                            this.mention_money_dlg=true;
                        }else if(res.data.code==510){
                            // 手续费有变化
                            this.message.ismessage('error',res.data.msg);
                            this.$router.push('/blockchain_w/transfer_p_fiat');
                        }else{
                            this.message.ismessage('error',res.data.msg);
                        }
                    })
                }
                
            }
        },
        dlg_close(){
            this.$router.push('/blockchain_w/transfer_p_fiat');
        }

    }
    
}
</script>

<style scoped>
.step1{
    max-width: 521px;
    margin:10px auto 40px;
    /* background: pink; */
    display: flex;
    justify-content: space-between;
    text-align: center;
}
.s_img_box{
    position: relative;
    display: inline-block;
}
.s_img1{
    width: 44px;
}
.div1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    margin-top: 12px;
    color: #DEB981;
}
.s_img2{
    width: 135px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -151px;
}
/* --表 table-- */
.th_info{
    background: #314B69;
    border-radius: 16px;
}
.th_info_top{
    box-sizing: border-box;
    padding: 28px;
    border-bottom: 1.5px solid #041E35;
}
.info_top1{
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 4px;
}
.info_top2{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.6);
}
.th_info_main{
    box-sizing: border-box;
    padding: 28px;
}
.th_tit1{
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    margin-bottom: 12px;
}
.th_tit2{
    margin-bottom: 12px;
    display: flex;
}
.th_info_main .th_tit2:last-child{
    margin-bottom: 0;
}
.th_tit3{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.6);
    width: 160px;
    margin-right: 28px;
    display: inline-block;
}
.th_tit4{
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    display: inline-block;
}
.title_bottom{
    margin-top: 40px;
}
.btn_box{
    min-width: 292px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: #04182A;
    margin-top: 40px;
    display: inline-block;
    cursor: pointer;
}
/* ---- */
.inp_box{
    width: 300px;
    position: relative;
    height: 48px;
    line-height: 48px;
}
.inp_box >>> .el-input__inner{
    background: #223C58;
    border: 1.5px solid rgba(49, 72, 105, 0.1);
    border-radius: 4px;
    color: #fff;
    height: 48px;
    line-height: 48px;
}
.inp2{
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  text-align: center;
  color: #DEB981;
  box-sizing: border-box;
  padding: 0 20px;
  border:1.5px solid #DEB981;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  position: absolute;
  right: 8px;
  top: 8px;
  height: 32px;
  line-height: 32px;
  background: #223C58;
}
.flex_center{
    align-items: center;
}

</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
    .flex_center {
        align-items: baseline;
    }
    .inp_box {
        width: 100%;
        position: inherit;
        height: inherit;
        line-height: 48px;
        display: flex;
        flex-direction: column;
    }
    .inp2 {
        position: inherit;
        height: 32px;
        line-height: 32px;
        margin-top: 15px;
    }
  
}
</style>
